module.exports = __webpack_public_path__ + "img/calendar-minus-fill.9b2ce931.svg";